export default {
    props: {
        messagesPause: {
            type: String,
            default: undefined,
            kComposite: 'messages.pause'
        }, 
        messagesPlay: {
            type: String,
            default: undefined,
            kComposite: 'messages.play'
        }, 
        messagesMute: {
            type: String,
            default: undefined,
            kComposite: 'messages.mute'
        }, 
        messagesUnmute: {
            type: String,
            default: undefined,
            kComposite: 'messages.unmute'
        }, 
        messagesQuality: {
            type: String,
            default: undefined,
            kComposite: 'messages.quality'
        }, 
        messagesFullscreen: {
            type: String,
            default: undefined,
            kComposite: 'messages.fullscreen'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-mediaplayer-vue-wrapper/src/KendoMediaPlayer/Messages.js